import aiAssistantCardFooters from '../../../consts/aiAssistant/aiAssistantCardFooters';
import aiAssistantProposalDefaults from '../../../consts/aiAssistant/aiAssistantProposalDefaults';
import {strCode} from '../../../consts/strCode';
import {CrossFade} from '../../CrossFade/CrossFade';
import AiAssistantWidgetSettings from '../AiAssistantWidgetSettings/AiAssistantWidgetSettings';
import AiAssistantWidgetText from '../AiAssistantWidgetText';
import AiAssistantCloseButton from './AiAssistantCloseButton';
import AiAssistantWidgetConfirmation from './AiAssistantWidgetConfirmation';
import AiAssistantWidgetProgress from './AiAssistantWidgetProgress';

const AiAssistantWidgetCard = ({proposal, footer, getSettingValue, onConfirm, onAutoClose, onClose}) => {
    // Padding inside the layers, so the NONE footer has zero height
    const footerLayers = {
        [aiAssistantCardFooters.CONFIRMATION]: (
            <div className='pt-4'>
                <AiAssistantWidgetConfirmation />
            </div>
        ),
        [aiAssistantCardFooters.PROGRESS]: (
            <div className='pt-4'>
                <AiAssistantWidgetProgress
                    durationMs={proposal.autoCloseMs ?? aiAssistantProposalDefaults.AUTO_CLOSE_MS}
                    onComplete={onAutoClose}
                />
            </div>
        ),
    };

    return (
        <div className='pointer-events-auto flex flex-col'>
            <div className='flex items-start gap-3'>
                {/* Placeholder copy: v1 sends no text and the copy isn't designed yet */}
                <div className='flex flex-1 flex-col gap-2'>
                    <AiAssistantWidgetText
                        strCode={strCode.AI_ASSISTANT_ACTION_TITLE_PLACEHOLDER}
                        isBold
                        className='tracking-[0.2px]'
                    />

                    <AiAssistantWidgetText strCode={strCode.AI_ASSISTANT_ACTION_DESCRIPTION_PLACEHOLDER} />
                </div>

                <AiAssistantCloseButton onClick={onClose} />
            </div>

            <div className='pt-4'>
                <AiAssistantWidgetSettings
                    settings={proposal.settings}
                    getSettingValue={getSettingValue}
                    onConfirm={onConfirm}
                />
            </div>

            <CrossFade activeKey={footer} layers={footerLayers} isSizedToActiveLayer />
        </div>
    );
};

export default AiAssistantWidgetCard;
